import {
    getMerchantDetails,
    getMerchantList,
} from '../../services/api/giftawayApi';
import {
    normalizeDenominations,
    normalizeMerchantInfo,
    normalizeMerchantList,
} from '../../services/giftawayUtils';
import {
    CLEAR_MERCHANT_INFO,
    GET_DENOMINATION_LIST,
    GET_MERCHANT_INFO,
    GET_MERCHANT_LIST,
} from './actionTypes';
import { hideLoading, showLoading } from './loadingActions';
import { notifyError } from './notificationActions';
import { updateEditorField } from './prizeActions';

export const getMerchantListAction = (merchantList) => {
    return {
        type: GET_MERCHANT_LIST,
        merchantList,
    };
};

export const getMerchantInfoAction = (merchant) => {
    return {
        type: GET_MERCHANT_INFO,
        merchant,
    };
};
export const getDenominationList = (denominations) => {
    return {
        type: GET_DENOMINATION_LIST,
        denominations,
    };
};
export const clearMerchantInfo = () => {
    return {
        type: CLEAR_MERCHANT_INFO,
    };
};

export function getMerchants() {
    return function (dispatch, getState) {
        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() => getMerchantList())
            .then((result) => normalizeMerchantList(result?.responseData))
            .then((merchantList) =>
                dispatch(getMerchantListAction(merchantList))
            )
            .catch((error) =>
                dispatch(
                    notifyError('Error', 'Unable to retrive the merchants')
                )
            )
            .finally(() => dispatch(hideLoading()));
    };
}

export function getMerchantInfo(merchantId) {
    return function (dispatch, getState) {
        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() => getMerchantDetails(merchantId))
            .then((result) => normalizeMerchantInfo(result?.responseData))
            .then((merchant) => dispatch(getMerchantInfoAction(merchant)))
            .then(() => {
                const state = getState();
                const { merchantInfo } = state?.merchant;
                dispatch(
                    updateEditorField(
                        'merchantName',
                        merchantInfo?.merchantName
                    )
                );
                return normalizeDenominations(merchantInfo?.denominations);
            })
            .then((denominations) =>
                dispatch(getDenominationList(denominations))
            )
            .catch((error) =>
                dispatch(
                    notifyError(
                        'Error',
                        'Unable to retrive the merchant details'
                    )
                )
            )
            .finally(() => dispatch(hideLoading()));
    };
}
